// Pure MapLibre helpers — no React state, no module-level mutation. These are
// the lowest-level glue between the demo's Layer config and the MapLibre GL
// imperative API.

import type maplibregl from "maplibre-gl";
import type { ExpressionSpecification } from "maplibre-gl";

export function setLayerVisibility(
  m: maplibregl.Map,
  layerId: string,
  visible: boolean
) {
  if (m.getLayer(layerId)) {
    m.setLayoutProperty(layerId, "visibility", visible ? "visible" : "none");
  }
}

// Build a MapLibre `match` expression that maps the `dominant_class` feature
// property onto a colour from the supplied palette, with a grey fallback.
// Used by every per-class fill layer (LULC, crops, forest, change).
export function buildClassColorExpr(
  colors: Record<string, string>
): ExpressionSpecification {
  const expr: unknown[] = ["match", ["get", "dominant_class"]];
  for (const [cls, color] of Object.entries(colors)) {
    expr.push(cls, color);
  }
  expr.push("#cccccc"); // fallback for any unmapped class
  return expr as unknown as ExpressionSpecification;
}

// Highlight / clear-highlight the `parcels-highlight` outline on each map
// passed in. Tolerant of nulls so the page can pass `[main, before]` without
// pre-checking — the before map only exists in comparison mode.
export function highlightParcelOn(
  maps: ReadonlyArray<maplibregl.Map | null>,
  pid: string
): void {
  for (const m of maps) {
    if (!m || !m.getLayer("parcels-highlight")) continue;
    m.setFilter("parcels-highlight", ["==", "cadastre_polygon_pid", pid]);
    m.setPaintProperty("parcels-highlight", "line-opacity", 1);
  }
}

export function clearParcelHighlightOn(
  maps: ReadonlyArray<maplibregl.Map | null>
): void {
  for (const m of maps) {
    if (!m || !m.getLayer("parcels-highlight")) continue;
    m.setFilter("parcels-highlight", ["==", "cadastre_polygon_pid", ""]);
    m.setPaintProperty("parcels-highlight", "line-opacity", 0);
  }
}
